module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiCn.b6828d6.ttf";